import styled from 'styled-components';

import { colors } from 'theme/theme';

export const DropdownListMenuSection = styled.div`
  & + & {
    border-top: solid 1px ${colors.selectionGrey};
  }

  width: 100%;
`;

export const DropdownListMenuSectionTitle = styled.div`
  color: ${colors.lightContentGrey};
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  text-decoration: none;
  letter-spacing: 1.8px;
  white-space: nowrap;
  display: block;
  margin: 0;
  padding: 12px;
  background-color: ${colors.backgroundBlue};
`;
